import { render, staticRenderFns } from "./info-contact.vue?vue&type=template&id=29425ba0&"
import script from "./info-contact.vue?vue&type=script&lang=js&"
export * from "./info-contact.vue?vue&type=script&lang=js&"
import style0 from "./info-contact.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports